import { Subject } from 'rxjs';
import { Engine } from '../Engine';
import { Scene } from './Scene';
import { SceneManifest } from './SceneManifest';
import { SceneLoadProgressEvent, SceneLoadProgressTracker } from './SceneLoadProgress';
import { RenderObject } from '../object/RenderObject';

export class SceneLoader {
  public readonly progress$ = new Subject<SceneLoadProgressEvent>();

  constructor(private engine: Engine) {}

  async loadScene(
    createScene: () => Scene,
    manifestUrl: string,
  ): Promise<{ scene: Scene; manifest: SceneManifest; namedObjects: Map<string, RenderObject[]> }> {
    // 1. Unload current scene
    this.engine.deactivateScene();

    // 2. Set up progress tracking
    const tracker = new SceneLoadProgressTracker();
    const sub = tracker.progress$.subscribe((event) => this.progress$.next(event));

    try {
      // 3. Create and load the new scene
      const scene = createScene();
      const { manifest, namedObjects } = await scene.loadManifest(manifestUrl, tracker);

      // 4. Activate the new scene (sync GL operations)
      this.engine.activateScene(scene);

      return { scene, manifest, namedObjects };
    } finally {
      sub.unsubscribe();
    }
  }
}
